/**
 * Created by quikr on 7/22/16.
 */

//Singleton class session to store data temporarily
  //current Usage -> redirect url to the page after login..
let employees = [{}];

employees = employees.map((employee) => {
  return (employee.EmpId + " " + employee.EmpName);

});
const session = new function () {
  this.date = null;
  this.loggedIn = false;
  this.roles = null;
  this.urls = '/1/home';

  this.employees = [];

  this.employees.sort(function (a, b) {
    return (a.empid - b.empid);
  })


  this.url_store = function (urls) {
    this.urls = urls;
  };
  this.url_get = function () {
    return (this.urls);
  };
  this.login = function (loggedIn, roles) {
    this.loggedIn = loggedIn;
    this.roles = roles;
  };
  this.roles = function (roles) {
    this.roles = roles;
  };

  this.logout = function () {
    this.loggedIn = false;
    this.roles = null;
    this.urls = '/1/home';
  };
  this.display = function () {
    /*eslint-disable no-console */
    console.log(this.loggedIn);
    console.log(this.roles);
  };
  this.isLoggedIn = function () {
    return this.loggedIn;
  };
  this.checkFeature = function (feature) {
    //console.log(this.roles[feature]);
    return (this.roles == null || this.roles[feature] == null || this.roles[feature] == undefined);
  };
};


export default  session;



/** WEBPACK FOOTER **
 ** ./src/classes/session.js
 **/